import instance from '../axios'
import type {
  AddFavoritePayload,
  AddWatchlistPayload,
  AddHistoryPayload,
  UpdateHistoryPayload,
  AddEpisodeToShowHistoryPayload,
  AddSeasonToShowHistoryPayload,
} from './user-media-api.types'

const userMediaApi = {
  getState: (token?: string) =>
    instance.get(`/user/media-state`, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  addFavorite: (payload: AddFavoritePayload, token: string) =>
    instance.post(`/favorites`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    }),
  deleteFavorite: (favoriteId: number, token: string) =>
    instance.delete(`/favorites/${favoriteId}`, {
      headers: { Authorization: `Bearer ${token}` },
    }),
  deleteFavoriteByTmdb: (tmdbMediaId: number, token: string) =>
    instance.delete(`/favorites/tmdb/${tmdbMediaId}`, {
      headers: { Authorization: `Bearer ${token}` },
    }),
  getFavoritesByUser: (userId: number, token: string) =>
    instance.get(`/favorites/${userId}`, {
      headers: { Authorization: `Bearer ${token}` },
    }),
  addWatchlist: (payload: AddWatchlistPayload, token: string) =>
    instance.post(`/watchlist`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    }),
  deleteWatchlist: (watchlistId: number, token: string) =>
    instance.delete(`/watchlist/${watchlistId}`, {
      headers: { Authorization: `Bearer ${token}` },
    }),
  deleteWatchlistByTmdb: (tmdbMediaId: number, token: string) =>
    instance.delete(`/watchlist/tmdb/${tmdbMediaId}`, {
      headers: { Authorization: `Bearer ${token}` },
    }),
  getWatchlistByUser: (userId: number, token: string) =>
    instance.get(`/watchlist/${userId}`, {
      headers: { Authorization: `Bearer ${token}` },
    }),
  addHistory: (payload: AddHistoryPayload, token: string) =>
    instance.post(`/history`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    }),
  updateHistory: (historyId: number, payload: UpdateHistoryPayload, token: string) =>
    instance.put(`/history/${historyId}`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    }),
  deleteHistory: (historyId: number, token: string) =>
    instance.delete(`/history/${historyId}`, {
      headers: { Authorization: `Bearer ${token}` },
    }),
  deleteHistoryByTmdb: (tmdbMediaId: number, token: string) =>
    instance.delete(`/history/tmdb/${tmdbMediaId}`, {
      headers: { Authorization: `Bearer ${token}` },
    }),
  getHistoryByUser: (userId: number, token: string) =>
    instance.get(`/history/${userId}`, {
      headers: { Authorization: `Bearer ${token}` },
    }),
  deleteEpisodeHistoryByTmdb: (tmdbEpisodeId: number, token: string) =>
    instance.delete(`/history/episode/${tmdbEpisodeId}`, {
      headers: { Authorization: `Bearer ${token}` },
    }),
  getWatchedEpisodes: (token: string) =>
    instance.get(`/history/episodes`, {
      headers: { Authorization: `Bearer ${token}` },
    }),
  addEpisodeToShowHistory: (showId: number, payload: AddEpisodeToShowHistoryPayload, token: string) =>
    instance.post(`/history/show/${showId}/episode`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    }),
  removeEpisodeFromShowHistory: (showId: number, episodeId: number, token: string) =>
    instance.delete(`/history/show/${showId}/episode/${episodeId}`, {
      headers: { Authorization: `Bearer ${token}` },
    }),
  addSeasonToShowHistory: (showId: number, payload: AddSeasonToShowHistoryPayload, token: string) =>
    instance.post(`/history/show/${showId}/season`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    }),
  removeSeasonFromShowHistory: (showId: number, seasonNumber: number, token: string) =>
    instance.delete(`/history/show/${showId}/season/${seasonNumber}`, {
      headers: { Authorization: `Bearer ${token}` },
    }),
  // Marks every aired episode (Specials excluded) as watched; server fetches
  // season data from TMDB itself, so no payload is needed.
  addAllEpisodesToShowHistory: (showId: number, token: string) =>
    instance.post<{ episodesMarked: number }>(`/history/show/${showId}/all`, null, {
      headers: { Authorization: `Bearer ${token}` },
    }),
}

export default userMediaApi
